import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastService } from './toast.service';
import { catchError } from 'rxjs';
import { API_URL } from '../../../app.config';
import { SpinnerService } from './spinner.service';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private readonly apiUrl = inject(API_URL);
  private showCsat = signal<boolean>(false);
  private pendingCsatValue = signal<boolean>(false);
  private hasPending = signal<boolean>(false);
  spinnerService = inject(SpinnerService);
  isloading = computed(() => this.spinnerService.loading());

  get _showCsat() {
    return this.showCsat();
  }
  set _showCsat(value: boolean) {
    this.showCsat.set(value);
  }

  constructor(
    private http: HttpClient,
    private toastService: ToastService,
  ) {
    effect(() => {
      if (!this.isloading() && this.hasPending()) {
        this.showCsat.set(this.pendingCsatValue());
        this.hasPending.set(false);
      }
    });
  }

  getCsat() {
    this.http
      .get<{ showCsat: boolean }>(`${this.apiUrl}CSat/GetCsat`)
      .pipe(
        catchError(error => {
          this.toastService.show(error.message, 'error');
          throw error;
        }),
      )
      .subscribe(data => {
        this.pendingCsatValue.set(data.showCsat);
        this.hasPending.set(true);
      });
  }

  postFeedback(rating: number, comment = '', source: string[] = []) {
    const feedback = { rating, comment, source };
    return this.http.post(`${this.apiUrl}CSat/SubmitFeedback`, feedback).pipe(
      catchError(error => {
        this.toastService.show(error.message, 'error');
        throw error;
      }),
    );
  }
}
